/**
 * @description: API接口管理文件
 * 所有接口变量定义均以: '_API' 结尾
 * 在每个接口上面写好接口用途注释
 */

export default {
	// 用户获取分享信息接口
	GET_SHARE_INFO_API: '/invite/get_share_info',
	// 通知服务端用户完成裂变邀请弹窗
	NOTICE_FISSION_MODAL_API: '/fission/windowDone',
	// 获取新裂变页数据接口
	GET_FISSION_PAGE_INFO_API: '/Fission/get_fission_page_info',
	// 获取裂变邀请奖励数据接口
	GET_RECORD_PAGE_INFO_API: '/Fission/get_invite_reward',
	// 获取我的奖励页邀请朋友列表
	GET_FRIEND_LIST_API: '/fission/get_friend_list',
	// 获取用户被邀请信息（用于弹窗）
	GET_INVITE_INFO_FOR_WINDOW_API: '/fission/getInvitedInfoForWindow',
	// 领取专属任务金奖励
	GET_LIMIT_TASK_BONUS: '/CashRewardLte/StartTask',
	// 专属任务金我知道了
	CLOSE_LIMIT_TASK_TIPS: '/CashRewardLte/CloseTips',
	// 获取限时任务活动页数据接口
	GET_LIMIT_ACTIVITY_PAGE_API: '/CashRewardLte/GetTaskInfoV2',
	// 获取限时任务活动页弹窗接口
	GET_LIMIT_PAGE_MODAL_API: '/CashRewardLte/GetTaskWindowV2',
	// 开启限时任务活动接口
	START_LIMIT_ACTIVITY_API: '/CashRewardLte/StartTaskV2',
	// 限时任务金结果弹框点击通知接口
	NOTICE_SERVER_CLICK_API: '/CashRewardLte/ConfirmResult',
	// 裂变页新人红包弹窗开启接口
	OPEN_WELFARE_MODAL_API: '/fission/openTen',
	// 裂变框架-好友页-我的收益
	GET_FISSION_INCOME_API: '/fission/myIncome',
	// 裂变框架-好友页-好友列表
	GET_FISSION_FRIEND_LIST_API: '/fission/friendListV2',
	// 裂变框架-每日签到-分享任务奖励领取
	GET_FS_SHARE_REWARD_API: '/task/signIn_share_reward',
	// 裂变框架-好友板块-提醒好友
	REMIND_FRIEND_API: '/fission/fission_push',
	// 裂变框架-提现板块-提现页数据
	GET_FISSION_WITHDRAW_API: '/fission_withdraw/get_page_info',
	// 裂变框架-提现板块-判断是否能提现
	JUDGE_CAN_WITHDRAW_API: '/fission_withdraw/can_withdraw',
	// 裂变框架-提现板块-获取验证码
	GET_VERIFY_CODE_API: '/me/send_sms_code',
	// 裂变框架-提现板块-绑定手机号码
	BIND_PHONE_NUM_API: '/me/bind_mobile',
	// 裂变框架-提现板块-提现接口
	SEND_WITHDRAW_API: '/fission_withdraw/withdraw',
	// 裂变框架-提现版块-小猪支付四要素认证接口
	Auth_WITHDRAW_INFO_API: '/withdrawl/identification',
	// 裂变框架-提现版块-微信实名认证接口
	BIND_WECHAT_NAME_API: '/withdrawl/bind_wx_real_name',
	// 裂变框架-提现版块-获取提现记录明细
	GET_FISSION_WITHDRAW_RECORD_API: '/fission_withdraw/get_withdraw_list',
	// 裂变框架-提现版块-提现结果页接口
	GET_FISSION_WITHDRAW_RESULT_API: '/fission_withdraw/get_result',
	//  每日首邀--开启任务
	OPEN_FIRST_INVITE_TASK: '/FirstInviteByDay/start_task',
	// 邀请引导-获取邀请弹窗奖励
	GET_INVITE_REWARD: '/invite/get_invited_reward',
	//  金币汇率分享奖励
	GET_ICONS_RATE_SHARE_REWARD: '/CoinRatePromote/share_reward',
	// 开启金币汇率
	OPEN_ICONS_RATE_TASK: '/CoinRatePromote/start_task',
	// 裂变框架二期-获取裂变活动数据接口
	GET_ACTIVITY_INFO_API: '/fission/get_page_info',
	// 裂变框架二期-裂变活动开启接口
	OPEN_ACTIVITY_API: '/fission/start_task',
	//  裂变-任务列表结果弹窗
	FISSION_RESULT_WINDOW_API: '/fission/resultWindow',
	//  裂变-领取任务奖励
	FISSION_GET_REWARD_API: '/fission/getReward',
	//  裂变完成列表任务
	FISSION_TASK_PROGRESS_API: '/fission/task_progress',
	//  新人分享奖励发放
	FISSION_SHARE_REWARD: '/fission/share_reward',
};



// WEBPACK FOOTER //
// ./src/service/api/modules/fission.js